import { pantryColors } from '@pantry/ui'
import React, { useState } from 'react'
import { FlowActivityList } from './FlowActivityList'
import { FlowCustomerView } from './FlowCustomerView'

const p = pantryColors

type ActivityView = 'activity' | 'customer'

const VIEWS: { key: ActivityView; label: string }[] = [
  { key: 'customer', label: 'Customer view' },
  { key: 'activity', label: 'Activity view' },
]

// An automation's Activity tab: its customers, or the trigger log.
export const FlowActivityTabs: React.FC<{
  storeId: string
  flowId: string
  // Abandoned cart flows have carts to show; other automations don't.
  cartFlow?: boolean
  enabled?: boolean
}> = ({ storeId, flowId, cartFlow = true, enabled = true }) => {
  const [view, setView] = useState<ActivityView>('customer')
  return (
    <div>
      <div
        role="tablist"
        aria-label="Activity views"
        style={{
          display: 'inline-flex',
          gap: 4,
          padding: 3,
          marginBottom: 12,
          borderRadius: 8,
          background: p.gray[100],
        }}
      >
        {VIEWS.map((v) => {
          const selected = view === v.key
          return (
            <button
              key={v.key}
              type="button"
              role="tab"
              aria-selected={selected}
              onClick={() => setView(v.key)}
              style={{
                padding: '5px 12px',
                border: 'none',
                borderRadius: 6,
                fontSize: 12.5,
                fontWeight: 600,
                cursor: 'pointer',
                background: selected ? p.white : 'transparent',
                color: selected ? p.gray[800] : p.gray[500],
                boxShadow: selected ? '0 1px 2px rgba(0,0,0,.1)' : 'none',
              }}
            >
              {v.label}
            </button>
          )
        })}
      </div>
      {view === 'activity' ? (
        <FlowActivityList storeId={storeId} flowId={flowId} enabled={enabled} />
      ) : (
        <FlowCustomerView
          storeId={storeId}
          flowId={flowId}
          cartFlow={cartFlow}
          enabled={enabled}
        />
      )}
    </div>
  )
}
